import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LabReqBaseComponent } from '../lab-req-base/lab-req-base.component';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'app-lab-req-nf',
  templateUrl: './lab-req-nf.component.html',
  styleUrls: ['./lab-req-nf.component.less']
})
export class LabReqNfComponent extends LabReqBaseComponent implements OnInit {
  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      signature: [''],
      patient: this.fb.group({
        hcn: [''],
        province: ['NL'],
        expiry: [''],
        name: [''],
        dob: [''],
        sex: [''],
        address: [''],
        city: [''],
        postalCode: [''],
        homeT: [''],
        mobileT: [''],
        workT: [''],
        homeTcheck: [false],
        mobileTcheck: [false],
        workTcheck: [false]
      }),
      provider: this.fb.group({
        name: [''],
        clinicName: [''],
        address: [''],
        city: [''],
        province: ['ON'],
        postalCode: [''],
        phone: [''],
        fax: [''],
        date: ['']
      }),
      stamp: this.fb.group({
        stamp: [''],
        meditech: [''],
        mnemonic: [''],
        copyProvider: ['']
      }),
      diagnosis: this.fb.group({
        diagnosis: ['']
      }),
      hematology: this.fb.group({
        cbc: [false],
        pti: [false],
        anticoagulant: ['']
      }),
      immunohematology: this.fb.group({
        bltyabs: [false]
      }),
      chemistry: this.fb.group({
        glufa: [false],
        gluco: [false],
        gtt2h: [false],
        g1hp50ggo: [false],
        gttg: [false],
        hba1cthb: [false],
        cr: [false],
        sodiu: [false],
        potas: [false],
        bilto: [false],
        alt: [false],
        calci: [false],
        urate: [false],
        prote: [false],
        album: [false],
        creki: [false],
        hepfup: [false],
        lipidp: [false],
        tsh: [false],
        crphs: [false],
        ferri: [false],
        psa: [false]
      }),
      frequency: this.fb.group({
        frequency: ['']
      }),
      therapeutic: this.fb.group({
        drug1: this.fb.group({
          selected: [false],
          name: [''],
          lastDoseDate: [''],
          lastDoseTime: [''],
          nextDoseDate: [''],
          nextDoseTime: ['']
        }),
        drug2: this.fb.group({
          selected: [false],
          name: [''],
          lastDoseDate: [''],
          lastDoseTime: [''],
          nextDoseDate: [''],
          nextDoseTime: ['']
        })
      }),
      urineTesting: this.fb.group({
        antibiotics: [''],
        urinap: [false],
        hcgu: [false],
        malcrpu: [false],
        urinc: [false],
        symptomatic: [false],
        pregnant: [false]
      }),
      prenatalScreening: this.fb.group({
        bltyabs: [false],
        pns: [false]
      }),
      microbiology: this.fb.group({
        hivs: [false],
        hbsab: [false],
        tpalab: [false],
        ctngdp: [false],
        ctngdpu: [false],
        hepdx: [false],
        havabm: [false]
      }),
      additionalRequests: this.fb.group({
        requests: ['']
      }),
      collection: this.fb.group({
        date: [''],
        time: [''],
        signature: [''],
        collectorNotes: ['']
      })
    });
  }
}
